<div class="creative-meta-wrapper">
    <ng-container *permissions="['Default', '!Export', 'CampaignActions']">
        <div
            *ngIf="publishInfo$ | async as publishInfo"
            class="ad-wrapper"
            [class.hidden]="!(publishInfo && publishInfo.connectedCampaigns.length > 0)">
            <ng-container *ngIf="!publishInfo.loading">
                <span
                    id="interaction-creative-open-campaigns"
                    *ngIf="!isPublishable"
                    class="ad-stats"
                    [uiDropdownTarget]="menu"
                    [uiTooltip]="'Open campaigns'"
                    [uiTooltipDisabled]="inTP"
                    (click)="$event.stopPropagation()">
                    <ui-svg-icon
                        class="ad-icon"
                        icon="campaigns-s"></ui-svg-icon>
                    <span class="ad-count">{{ publishInfo.connectedCampaigns.length }}</span>
                </span>

                <span
                    id="creative-push-changes"
                    *ngIf="isPublishable"
                    class="ad-stats"
                    data-sentry="creative-item-push-changes"
                    [uiTooltip]="'Push changes'"
                    [uiTooltipDisabled]="inTP"
                    (click)="publishChanges($event)">
                    <ui-svg-icon
                        class="ad-icon active"
                        icon="campaigns-s"></ui-svg-icon>
                    <span class="ad-count">{{ publishInfo.connectedCampaigns.length }}</span>
                </span>
            </ng-container>

            <div
                *ngIf="publishInfo.loading"
                class="ad-loader">
                <ui-loader></ui-loader>
            </div>
        </div>
    </ng-container>

    <div
        class="target-url"
        *ngIf="creative?.targetUrl && !inShowcase"
        (click)="overrideTargetUrl()">
        <ui-svg-icon
            [uiTooltip]="creative?.targetUrl"
            icon="link-s"></ui-svg-icon>
    </div>

    <ng-container *ngIf="!(publishInfo$ | async)?.loading">
        <div
            class="comments-wrapper"
            *ngIf="commentService.commentCount(commentsToken, creative?.id)">
            <div
                class="comments"
                [class.active]="commentsActive"
                #commentsThread="csThreads"
                *permissions="'Comments'"
                [csThreads]="{ tokenId: commentsToken, parentId: creative?.id }"
                (click)="$event.stopPropagation()">
                <ui-svg-icon icon="comments"></ui-svg-icon>
                <span>{{ commentService.commentCount(commentsToken, creative?.id) }}</span>
            </div>
        </div>
    </ng-container>

    <ui-dropdown
        #menu
        [disabled]="inTP"
        type="menu"
        [offset]="{ x: 0, y: 10 }">
        <ui-dropdown-item [disabled]="true">Open Campaigns</ui-dropdown-item>
        <ui-dropdown-item
            *ngFor="let campaign of (publishInfo$ | async)?.connectedCampaigns"
            svgIcon="display-campaign"
            [uiTooltip]="campaign.name"
            (click)="openCampaign(campaign.id)">
            {{ campaign.name | dotdotdot: 15 }}
        </ui-dropdown-item>
    </ui-dropdown>
</div>
<ng-container *ngIf="!(publishInfo$ | async)?.loading">
    <div
        class="no-comments-wrapper"
        *ngIf="!commentService.commentCount(commentsToken, creative?.id)">
        <div
            class="comments"
            [class.active]="commentsActive"
            [csThreads]="{ tokenId: commentsToken, parentId: creative?.id }"
            #commentsThread="csThreads"
            [class.hidden]="!commentService.commentCount(commentsToken, creative?.id)"
            *permissions="'Comments'"
            (click)="$event.stopPropagation()">
            <ui-svg-icon icon="comments-add"></ui-svg-icon>
        </div>
    </div>
</ng-container>
